if (typeof TestimonialsTextOnly != 'function') {
	class TestimonialsTextOnly extends HTMLElement {
		constructor() {
			super();

			this.uniqueClass = `.splide--${this.dataset.id}`;
			this.slider = this.querySelector('.splide');
			this.slides = this.slider.querySelectorAll('.splide__slide');
			this.autoplay = /true/.test(this.slider.dataset.autoplay);
			this.speed = this.slider.dataset.speed * 1000 || 3000;
			this.showArrows = /true/.test(this.slider.dataset.showArrows);

			if (window.Shopify.designMode) {
				document.addEventListener('shopify:section:load', () => {
					this.init();
				});
			}
		}

		connectedCallback() {
			this.init();
		}

		init() {
			new Splide(this.uniqueClass, {
				type: 'fade',
				perPage: 1,
				arrows: this.showArrows,
				fade: true,
				pagination: false,
				autoplay: this.autoplay === 'true',
				lazyLoad: 'nearby',
				interval: this.speed,
				rewind: true,
			}).mount();
		}
	}
	if (!customElements.get('text-testimonials')) {
		customElements.define('text-testimonials', TestimonialsTextOnly);
	}
}
